import { TextInput, required, maxLength } from "react-admin";
import { Grid } from "@mui/material";
import { RichTextInput } from "ra-input-rich-text";
import CustomTimeInput from "server/components/Fields/CustomTimeInput";
import { settings } from "app";

const EditStudyDepartmentInfoForm = () => (
  <Grid
    container
    spacing={2}
  >
    <Grid
      item
      xs={12}
      md={6}
    >
      <TextInput
        label="Адрес"
        source="addressBg"
        validate={[required(), maxLength(250)]}
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <TextInput
        label="Адрес на английски"
        source="addressEn"
        validate={[required(), maxLength(250)]}
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <RichTextInput
        label="Документи за записване"
        source="enrollmentDocumentsBg"
        sx={settings.style.richTextInput}
        validate={[required(), maxLength(2000)]}
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <RichTextInput
        label="Документи за записване на английски"
        source="enrollmentDocumentsEn"
        sx={settings.style.richTextInput}
        validate={[required(), maxLength(2000)]}
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={3}
    >
      <CustomTimeInput
        source="workingTimeFrom"
        label="Работно време от"
        validate={required()}
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={3}
    >
      <CustomTimeInput
        label="Работно време до"
        source="workingTimeTo"
        validate={required()}
      />
    </Grid>
  </Grid>
);

export default EditStudyDepartmentInfoForm;
